import axios from 'axios';
import { message } from 'antd'

import { axiosApiInstance } from '../../services/axiosApiInstance';

const api = `${process.env.REACT_APP_API_URL}/api/v1/dashboard/summaryInfo`;

export interface GetSummaryDashBoard {
    wirelessClientsCount: number;
    configuredNetworksCount: number;
    currentlyActiveNetworksCount: number;
    currentNetworkThroughputInBitsPerSecond: number;
    totalDataTransferredDuringLast24HoursInBytes: number;
    configuredWiredNetworksCount: number;
    currentlyActiveWiredNetworksCount: number;
    configuredWirelessNetworksCount: number;
    currentlyActiveWirelessNetworksCount: number;
    activeAlertsCount: number;
    groupedWiredClientsCount: number;
    deviceEntitiesCount: number;
    deviceEntitiesUpCount: number;
    deviceCount: number;
    deviceUpCount: number;
    wiredClientsCount: number;
    totalSites: number;
}

async function getDashBoardData() {
    try {
        const response = await axiosApiInstance.get(api);
        return response?.data;
    }
    catch (error: any) {
        console.log('error_api_dashboard', error);
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.data.detail) {
                if (error.response.status !== 401) {
                    const msg = error.response.data.detail
                    message.error(msg, 5);
                }
            }
        }
        else {
            message.error("Some error occurred", 5);
        }
    }
}

export {
    getDashBoardData
}